module.exports = __webpack_public_path__ + "img/content_bundles.3fb13252.svg";